import React from 'react';
import LanguageSettings from '../setting_components/LanguageSettings';

class SignUpLanguages extends React.Component {
  render() {
    return (
      <div className="onboarding-page-wrap">
        <div className="onboarding-page">
          <LanguageSettings nextButton={this.props.nextButton} />
        </div>
      </div>
    );
  }
}

export default SignUpLanguages;
